import React, { Component } from 'react';
import HighchartsReact from 'highcharts-react-official';
import addTreemapModule from 'highcharts/modules/treemap';
import Highcharts from 'highcharts';
import addHeatMap from 'highcharts/modules/heatmap';

addHeatMap(Highcharts);
addTreemapModule(Highcharts);
let self;
const chartOptions = {
  colorAxis: {
    stops: [
      [0, '#f54242'],
      [0.25, '#f55542'],
      [0.5, '#f58543'],
      [0.75, '#f5e743'],
      [1.0, '#42f55d'],
    ],
    startOnTick: false,
    endOnTick: false,
    min: 0,
    max: 1,
  },
  plotOptions: {
    treemap: {
      allowPointSelect: true,
    },
  },
  credits: {
    enabled: false,
  },
  series: [
    {
      type: 'treemap',
      layoutAlgorithm: 'squarified',
      alternateStartingDirection: true,
      levels: [
        {
          level: 1,
          layoutAlgorithm: 'sliceAndDice',
          dataLabels: {
            enabled: true,
            align: 'left',
            verticalAlign: 'top',
            style: {
              fontSize: '15px',
              fontWeight: 'bold',
            },
          },
          borderWidth: 5,
        },
      ],
      events: {
        click(event) {
          self.props.onHeatMapBoxClick(event.point.extraVal);
        },
      },
      data: [],
      tooltip: {
        pointFormat:
          '<b>COF : {point.COFValue} Kr.<br/> POF : {point.POFValue} % <br/>Obj Id: {point.extraVal} <br/> #consumers : {point.CPS} <br/> Model : {point.Model}</b>',
      },
    },
  ],
  title: {
    text: 'PoF (%), Colour = POF, Size = COF',
    layout: 'horizontal',
    borderWidth: 0,
    backgroundColor: 'rgba(255,255,255,0.85)',
    floating: true,
    verticalAlign: 'bottom',
  },
};

class HeatMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chartOptions,
      init: false,
    };
    self = this;
    this.textInput = React.createRef();
  }

  UNSAFE_componentWillMount() {
    this.bindData(this.props.data);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.selectedValue !== nextProps.selectedValue) {
      if (
        this.textInput.current.chart.series[0].data.filter(
          (x) => x.extraVal === this.props.selectedValue.toString()
        ).length > 0
      ) {
        this.textInput.current.chart.series[0].data
          .filter((x) => x.extraVal === this.props.selectedValue.toString())[0]
          .graphic.element.removeAttribute('style');
      }
      this.textInput.current.chart.series[0].data
        .filter((x) => x.extraVal === nextProps.selectedValue.toString())[0]
        .graphic.element.setAttribute('style', 'fill: red');
    }
  }

  shouldComponentUpdate(nextprops) {
    if (this.props.data.length !== nextprops.data.length) {
      return true;
    }
    return false;
  }

  bindData(data) {
    const Obj = [];
    const unique = [...new Set(data.map((item) => item.AssetName))];

    unique.forEach((element) => {
      Obj.push({
        id: element,
        name: element,
      });
    });

    data.forEach((element) => {
      Obj.push({
        parent: element.AssetName,
        value: element.COF,
        extraVal: element.CableObjectId,
        POFValue: element.POF,
        COFValue: element.COF,
        CPS: element.ConsumersPerCS,
        Model: element.Model,
        colorValue: element.POF,
      });
    });

    const chrt = this.state.chartOptions;
    chrt.series[0].data = Obj;
    this.setState({
      chartOptions: chrt,
    });
  }

  render() {
    const { chartOptions } = this.state;
    return (
      <HighchartsReact
        ref={this.textInput}
        highcharts={Highcharts}
        options={chartOptions}
      />
    );
  }
}
export default HeatMap;
